export const DATA_MANAGEMENT_TYPES = {
  DATA_RETENTION: 'data_retention',
};
